import React from 'react';

class Installation extends React.Component {
    render() {
        return(
            <section className="install">
                <div className="install__block">
                    <div className="install__text-block">
                        <div className="install__item">
                            <div className="install__goods">Неограниченное использование системы, включая полную
                                техническую поддержку за одно активное подключение оператора (постоплата по итогам
                                месяца)
                            </div>
                            <div className="install__price install__price_red">90 руб. в сутки</div>
                            <div className="install__or">или</div>
                            <div className="install__goods">При использовании постоянных поключений 
                            </div>
                            <div className="install__price install__price_red">17 руб. в сутки</div>
                        </div>
                        <div className="install__item">
                            <div className="install__goods">Первоначальная настройка аккаунта, включая выделенный IP-адрес для Вашей телефонной станции</div>
                            <div className="install__price">15 000 руб.</div>
                        </div>
                        <div className="install__item">
                            <div className="install__goods">Минимальная сумма счета по итогам работы в течении месяца</div>
                            <div className="install__price">2 000 руб.</div>
                        </div>
                        <div className="install__item">
                            <div className="install__goods">Стоимость бессрочных постоянных подключений для операторов</div>
                            <div className="install__price">23 000 руб. за 1 подключение</div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Installation;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/Installation.js